import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function ReasonsSection() {
  const reasons = [{
    icon: '🥗',
    title: 'SALUD',
    subtitle: 'Porque quieren saber qué están comiendo',
    desc: 'Cada vez más personas buscan alimentos más naturales, frescos y cultivados por ellos mismos.'
  }, {
    icon: '💰',
    title: 'AHORRO',
    subtitle: 'Porque todo está cada vez más caro',
    desc: 'Producir en casa, aunque sea una parte, empieza a generar una diferencia real.'
  }, {
    icon: '🐾',
    title: 'MASCOTAS',
    subtitle: 'Porque quieren un hogar seguro para sus mascotas',
    desc: 'No todas las plantas son seguras, y saber cuáles elegir cambia todo.'
  }, {
    icon: '📈',
    title: 'INGRESOS',
    subtitle: 'Porque quieren generar dinero desde casa',
    desc: 'Muchos empiezan con pocas plantas… y terminan vendiendo.'
  }, {
    icon: '🧘',
    title: 'BIENESTAR',
    subtitle: 'Porque necesitan un espacio que los desconecte',
    desc: 'Un rincón verde puede cambiar completamente cómo se siente tu casa.'
  }, {
    icon: '🌱',
    title: 'PRINCIPIANTES',
    subtitle: 'Porque quieren empezar algo nuevo… pero bien hecho',
    desc: 'Sin frustrarse, sin perder tiempo y sin abandonar.'
  }];
  return <section className="relative bg-white py-10 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-138">
      {/* Decorative elements */}
      <div className="absolute -top-20 -right-20 w-72 h-72 bg-garden-bg rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-139"></div>
      <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-earth-light/20 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-140"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-141">
        <div className="text-center mb-8" data-id="element-142">
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A] mb-3 leading-tight" data-id="element-143">
            ¿Por qué cada vez más personas están empezando su huerta en casa?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-144">
            No es solo por tener plantas. Cada persona empieza por una razón
            distinta…
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mb-8" data-id="element-145">
          {reasons.map((reason, i) => <div key={i} className="bg-neutral-bg rounded-2xl p-5 sm:p-6 border border-neutral-beige shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group" data-id="element-146">
              <div className="flex items-center gap-3 mb-3" data-id="element-147">
                <div className="w-12 h-12 flex-shrink-0 bg-white rounded-xl flex items-center justify-center text-2xl shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-148">
                  {reason.icon}
                </div>
                <h3 className="text-xs font-black text-garden-dark uppercase tracking-widest" data-id="element-149">
                  {reason.title}
                </h3>
              </div>
              <p className="font-serif text-base sm:text-lg font-bold text-[#1A1A1A] mb-2 leading-snug" data-id="element-150">
                {reason.subtitle}
              </p>
              <p className="text-sm text-gray-600 font-medium leading-relaxed" data-id="element-151">
                {reason.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-152">
          <p className="text-base sm:text-lg text-gray-700 font-medium max-w-3xl mx-auto mb-6 leading-relaxed bg-neutral-bg px-6 py-4 rounded-2xl border border-neutral-beige inline-block" data-id="element-153">
            Y aunque cada persona empieza por algo distinto… todas necesitan lo
            mismo:{' '}
            <span className="font-black text-garden-dark" data-id="element-154">
              saber cómo hacerlo bien desde el inicio.
            </span>
          </p>

          <div className="relative inline-block group" data-id="element-155">
            <div className="absolute -inset-1 bg-gradient-to-r from-garden-medium to-garden-dark rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 animate-pulse-glow" data-id="element-156"></div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center bg-gradient-garden hover:from-[#1e3d25] hover:to-garden-dark text-white font-black text-lg sm:text-xl py-4 px-10 sm:px-14 rounded-full shadow-xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-157">
              👉 QUIERO EMPEZAR MI HUERTA HOY
            </a>
          </div>
        </div>
      </div>
    </section>;
}